import { Grid, TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
function LighthouseForm(props) {
  const [FID, setFID] = useState("");
  const [Shape, setShape] = useState("");
  const [FLASHING, setFLASHING] = useState("");
  const [LICOLOR, setLICOLOR] = useState("");
  const [PERIOD_S_, setPERIOD_S_] = useState("");
  const [HEIGHT_M_, setHEIGHT_M_] = useState("");
  const [RANGE_M_, setRANGE_M_] = useState("");
  const [CODE, setCODE] = useState("");
  useEffect(() => {
    let data = {
      FID: FID,
      Shape: Shape,
      FLASHING: FLASHING,
      LICOLOR: LICOLOR,
      PERIOD_S_: PERIOD_S_,
      CODE: CODE,
      HEIGHT_M_: HEIGHT_M_,
      RANGE_M_: RANGE_M_,
    };
    props.setData(data);
  }, [FID, Shape, FLASHING, LICOLOR, PERIOD_S_, CODE, HEIGHT_M_, RANGE_M_]);
  return (
    <>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={FID}
            onChange={(e) => setFID(e.target.value)}
            variant="outlined"
            label="FID"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={Shape}
            onChange={(e) => setShape(e.target.value)}
            variant="outlined"
            label="Shape"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={FLASHING}
            onChange={(e) => setFLASHING(e.target.value)}
            variant="outlined"
            label="FLASHING"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={LICOLOR}
            onChange={(e) => setLICOLOR(e.target.value)}
            variant="outlined"
            label="LICOLOR"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={PERIOD_S_}
            // eslint-disable-next-line no-undef
            onChange={(e) => setPERIOD_S_(e.target.value)}
            variant="outlined"
            label="PERIOD_S_"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={HEIGHT_M_}
            // eslint-disable-next-line no-undef
            onChange={(e) => setHEIGHT_M_(e.target.value)}
            variant="outlined"
            label="NAME"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={RANGE_M_}
            // eslint-disable-next-line no-undef
            onChange={(e) => setRANGE_M_(e.target.value)}
            variant="outlined"
            label="RANGE_M_"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={CODE}
            onChange={(e) => setCODE(e.target.value)}
            variant="outlined"
            label="CODE"
            size="small"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default LighthouseForm;
